import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { AsyncPipe } from '@angular/common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { UserState } from '../../states/user.state';
import { IUser } from '../../interfaces/IUser';
import { IPersistentFilter } from '../../interfaces/employee/IPersistentFilter';
import { DatePipe } from '../../pipes/date.pipe';
import { DateService } from '../../services/date.service';
import { AssigneeAvatarComponent } from '../assignee-avatar/assignee-avatar.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatMenuTrigger, MatMenu, MatMenuItem, AsyncPipe, TranslatePipe, DatePipe, AssigneeAvatarComponent],
})
export class UserComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private authService = inject(AuthService);
  private store = inject(Store);
  private dateService = inject(DateService);
  protected user$: Observable<IUser> = this.store.select<IUser>(UserState.user);
  private filters$: Observable<IPersistentFilter> = this.store.select<IPersistentFilter>(UserState.filters);
  public message: string;
  public lastMonthlySettlement: string;
  public lastApprovedMonth: string;
  public accountingMonth: string;
  public lastSettlementRun: string;
  public menuIsOpen = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    this.setUserInformation();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  protected isImpersonating(): boolean {
    return this.authService.impersonatedUser() != null;
  }

  private setUserInformation(): void {
    this.filters$
      .pipe(
        tap(filters => {
          this.accountingMonth = filters.accountingMonth;
          this.lastSettlementRun = filters.lastRunDate;
          localStorage.setItem('accountingMonth', filters.accountingMonth);
          this.dateService.accountingMonth = this.accountingMonth;
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();

    this.user$
      .pipe(
        tap(user => {
          this.lastMonthlySettlement = user.lastMonthlySettlement;
          this.lastApprovedMonth = user.lastApprovedMonth;
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
